import { Search } from '@mui/icons-material';
import { TextField } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const handleFilterChange = (event, updateFilter) => {
    const newValue = event.target.value;
    updateFilter(newValue);
};
export const Filter = ({ value, updateFilter }) => {
    const { t } = useTranslation();

    return (
        <TextField
            value={value}
            onChange={(event) => handleFilterChange(event, updateFilter)}
            id="outlined-basic"
            fullWidth
            autoComplete="off"
            label={
                value.length === 0 ? (
                    <span>
                        <Search fontSize="small" />
                        {t('Common.search')}
                    </span>
                ) : (
                    ' '
                )
            }
        />
    );
};
